import { render, staticRenderFns } from "./kneeout.vue?vue&type=template&id=56435d49&scoped=true&"
import script from "./kneeout.vue?vue&type=script&lang=js&"
export * from "./kneeout.vue?vue&type=script&lang=js&"
import style0 from "./kneeout.vue?vue&type=style&index=0&id=56435d49&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56435d49",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56435d49')) {
      api.createRecord('56435d49', component.options)
    } else {
      api.reload('56435d49', component.options)
    }
    module.hot.accept("./kneeout.vue?vue&type=template&id=56435d49&scoped=true&", function () {
      api.rerender('56435d49', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/traning/kneeout.vue"
export default component.exports